export default "__VITE_ASSET__DalB3Zc6__"